import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import t from "../../../_internal/icon-switch-transition/src/IconSwitchTransition.js";
import a from "../../../_internal/loading/src/Loading.js";
import i from "../../../_internal/icon/src/Icon.js";
import o from "../../../_internal/icons/ChevronRight.js";
import { defineComponent as d, h as e } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const f = d({
  name: "DataTableExpandTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    expanded: Boolean,
    loading: Boolean,
    onClick: {
      type: Function,
      required: !0
    },
    renderExpandIcon: {
      type: Function
    },
    rowData: {
      type: Object,
      required: !0
    }
  },
  render() {
    const {
      clsPrefix: r
    } = this;
    return e("div", {
      class: [`${r}-data-table-expand-trigger`, this.expanded && `${r}-data-table-expand-trigger--expanded`],
      onClick: this.onClick,
      onMousedown: (n) => {
        n.preventDefault();
      }
    }, e(t, null, {
      default: () => this.loading ? e(a, {
        key: "loading",
        clsPrefix: this.clsPrefix,
        radius: 85,
        strokeWidth: 15,
        scale: 0.88
      }) : this.renderExpandIcon ? this.renderExpandIcon({
        expanded: this.expanded,
        rowData: this.rowData
      }) : e(i, {
        clsPrefix: r,
        key: "base-icon"
      }, {
        default: () => e(o, null)
      })
    }));
  }
});
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/ExpandTrigger.js
// module id = 1612
// module chunks = 41